<template>
    <div class="exception-body access-denied">
        <div class="exception-panel">
            <h1>ACCESS</h1>
            <h3>denied</h3>
            <p>You are not allowed to view this page.</p>
            <div>
                <router-link to="/">
                    <Button type="button" label="Back to Home Page"></Button>
                </router-link>
                <br />
                <router-link to="/login">
                    <Button type="button" label="Log In"></Button>
                </router-link>
            </div>
        </div>
        <div class="exception-footer">
            <img :src="'layout/images/logo-' + color + '.png'" class="exception-logo" />
            <img :src="'layout/images/appname-' + color + '.png'" class="exception-appname" />
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            color: this.$appState.defaultColorScheme,
        };
    },
};
</script>
